import type { CSSProperties, ReactNode } from 'react';

import styles from './carouselCard.module.css';
import { Box } from '@jane/shared/reefer';

export type ScrollSnapAlignType = 'none' | 'start' | 'end' | 'center';

export interface CarouselCardProps {
  /** Carousel children, add carousel cards here */
  children: ReactNode;

  /** Set `scroll-snap-align` css property of card */
  scrollSnapAlign?: ScrollSnapAlignType;

  /** Width of the card on desktop / tablet  */
  width?: number | string;

  /** Width of the card on mobile */
  widthMobile?: number | string;
}

export function CarouselCard({
  children,
  scrollSnapAlign = 'start',
  widthMobile,
  width,
}: CarouselCardProps) {
  return (
    <Box
      className={styles.card}
      height="100%"
      style={
        {
          // expose values via custom properties for the CSS Module to consume
          '--carousel-card-scroll-snap-align': scrollSnapAlign,
          '--carousel-card-width-mobile':
            typeof widthMobile === 'number' ? `${widthMobile}px` : widthMobile,
          '--carousel-card-width':
            typeof width === 'number' ? `${width}px` : width,
        } as CSSProperties
      }
    >
      {children}
    </Box>
  );
}
